import {
  IBookableService,
  IBookableServiceListParams,
  ICreateBookableServicePayload,
  IPaginatedResponse,
  IUpdateBookableServicePayload
} from '@pharvio/core/shared';
import { Observable } from 'rxjs';

export abstract class BookableServicesDataService {
  abstract getServices(
    params?: IBookableServiceListParams
  ): Observable<IPaginatedResponse<IBookableService>>;

  abstract getService(id: string): Observable<IBookableService>;

  abstract createService(
    payload: ICreateBookableServicePayload
  ): Observable<IBookableService>;

  /** `branchIds` replaces the whole assignment set; empty = every branch. */
  abstract updateService(
    id: string,
    payload: IUpdateBookableServicePayload
  ): Observable<IBookableService>;

  /**
   * Soft delete. Refused with 409 `SERVICE_HAS_OPEN_BOOKINGS` while bookings
   * are still open against it — offer "deactivate instead", which is an
   * ordinary `updateService(id, { isActive: false })`.
   */
  abstract deleteService(id: string): Observable<void>;
}
